export const marginReportsStoreKey = 'marginReports';
